export default () => ({
  confirmAndVisit(message: string, href: string) {
    if (window.confirm(message)) {
      window.location.assign(href);
    }
  },
});
